import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "Where does the data come from?",
    a: "DataSniper analyzes publicly available signals — search trend platforms, public forums (Reddit, Quora, niche communities), industry publications, business directories, and competitor mentions across the open web. We never scrape behind logins or use private data.",
  },
  {
    q: "Is this legal?",
    a: "Yes.",
  },
  {
    q: "How much will it cost?",
    a: "It is free.",
  },
  {
    q: "Can I use DataSniper for a specific city or region?",
    a: "Yes.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <p className="text-[11px] tracking-[0.32em] uppercase text-[#FF5000] mb-4">
          · Frequently asked
        </p>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.05] mb-14">
          Questions, answered.
        </h2>

        <div className="border-t border-neutral-900">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="border-b border-neutral-900">
                <button
                  data-testid={`faq-q-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-start justify-between gap-6 py-6 md:py-7 text-left group"
                >
                  <span className="text-white text-lg md:text-xl font-medium tracking-tight leading-snug">
                    {f.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 mt-1 flex-shrink-0 transition-transform duration-300 ${
                      isOpen ? "rotate-180 text-[#FF5000]" : "text-neutral-500 group-hover:text-white"
                    }`}
                  />
                </button>
                <div
                  className="overflow-hidden transition-all duration-300 ease-out"
                  style={{ maxHeight: isOpen ? 240 : 0, opacity: isOpen ? 1 : 0 }}
                >
                  <p className="pb-7 pr-12 text-neutral-400 text-[15px] md:text-base leading-relaxed">
                    {f.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
